// extracted by mini-css-extract-plugin
export default {"socials":"Socials_socials__ecuYn","icons":"Socials_icons__vSgXI"};